/**
 * PC_TF_01
 * Importing the component, API and packages
 */
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import { postTouchbase, updateTouchbase, getIndividualTouchbase, directory } from '../../service/PerformanceAPI';
import Select from 'react-select';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import moment from 'moment';
import Loader from '../../StaticComponent/Loader';
import { NotificationTrigger, OnlyNumberSpecialChar } from '../../utils/RegHandling';
import { connect } from 'react-redux';
import _ from 'lodash';
import { encryptStorage } from '../../constant';

function TouchbaseForm({ websocket }) {
    const { touchbaseId } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();

    /**
     * PC_TF_02
     * State variables are created
     */

    let dataObj = {
        touchbaseId: '',
        touchbaseTitle: '',
        touchbaseDescription: '',
        touchbaseType: '',
        touchbaseDate: '',
        touchbaseStartTime: '',
        touchbaseEndTime: '',
        touchbaseStatus_id: '',
        touchbaseAttendees: [],
    };
    let dataObjOld = {
        touchbaseId: '',
        touchbaseTitle: '',
        touchbaseDescription: '',
        touchbaseType: '',
        touchbaseDate: '',
        touchbaseStartTime: '',
        touchbaseEndTime: '',
        touchbaseStatus_id: '',
        touchbaseAttendees: [],
    };

    let details = { role: '', roleId: '', week: 0, domain: '' };
    const [touchbaseData, setTouchbaseData] = useState(dataObj);
    const [touchbaseDataOld, setTouchbaseDataOld] = useState(dataObjOld);
    const [pageMode, setPageMode] = useState(false);
    const [userDetails, setUserDetails] = useState(details);
    const [showEmployee, setShowEmployee] = useState([]);
    const [emp, setEmp] = useState([]);
    const [selectedPeopleList, setSelectedPeopleList] = useState([]);
    const [touchbaseValidation, setTouchbaseValidation] = useState('');
    const [touchbaseAttendees, settouchbaseAttendees] = useState('');
    const [date, setDateDetails] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [descriptionValidation, setdescriptionValidation] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [breadCrumbsData, setbreadCrumbsData] = useState([]);

    const [disabledCheck, setDisabledCheck] = useState(false);
    const [disableSubmitBtn, setdisableSubmitBtn] = useState(false);
    const [oldSelectedValue, setOldSelectedValue] = useState([]);

    /**
     * PC_TF_03
     * useEffect is invoked and role is defined then loadTouchbaseData function is called
     */

    useEffect(() => {

        if (encryptStorage.getItem('groupid') == '1' || encryptStorage.getItem('groupid') == '2') {
            setdisableSubmitBtn(false);
            userDetails.roleId = encryptStorage.getItem('employeeId');
            // userDetails.role = encryptStorage.getItem("role")
            userDetails.role = encryptStorage.getItem('role') === 'Hr' ? 'Hr Manager' : encryptStorage.getItem('role');

            userDetails.domain = encryptStorage.getItem('department');

            loadTouchbaseData();
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    }, []);

    useEffect(() => {
        if (pageMode) {
            // let data = validation()

            let isSame = _.isEqual(touchbaseData, touchbaseDataOld);
            oldSelectedValue.filter((o1) => !selectedPeopleList.some((o2) => o1.value === o2.value)).length > 0
                ? setDisabledCheck(false)
                : isSame
                    ? setDisabledCheck(true)
                    : setDisabledCheck(false);

            // if (isSame) {
            //     setDisabledCheck(true)
            // }
            // else if (!isSame) {
            //     setDisabledCheck(false)
            // }
        }
    }, [touchbaseData, touchbaseDataOld, disabledCheck]);

    const bind = async (value) => {
        //;
        let empResult;
        if (value === 'team') {
            empResult = await directory({ domain: 'domain' });
        } else if (userDetails.role == 'Hr Manager') {
            empResult = await directory({});
        } else {
            empResult = await directory({ empId: userDetails.roleId });
        }
        let samplearray = [];
        let selectedarray = [];
        let temparray = empResult.data.ResponseData.emplist;
        for (let i = 0; i <= temparray.length - 1; i++) {
            let objresponse = {
                value: temparray[i].emp_id,
                label: temparray[i].emp_name,
                username: temparray[i].emp_name,
            };
            if (state?.employeeId == temparray[i].emp_id) {
                selectedarray.push(objresponse);
            } else samplearray.push(objresponse);
        }
        setShowEmployee(samplearray);
        if (selectedarray.length > 0) {
            let attend = [];
            setSelectedPeopleList(selectedarray);
            selectedarray.map((data) => {
                attend.push(data?.value);
            });
            setEmp(attend);
            setTouchbaseData({ ...touchbaseData, ['touchbaseAttendees']: selectedarray });
        }
    };

    /**
     * PC_TF_03, PC_TF_04, PC_TF_05
     * touchbaseId is retrived from url then  is invoked then getIndividualTouchbase function is called
     */

    const loadTouchbaseData = async () => {
        if (userDetails.role != 'Team Member' && !state?.View) {
            setbreadCrumbsData([
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: 'Team Member', path: '', isActive: true },
                { title: 'Touchbase', path: '/touchbase', isActive: true },
                { title: 'Touchbase Form', path: '/', isActive: false },
            ]);
        } else if (state?.View) {
            setbreadCrumbsData([
                { title: 'Dashboard', path: '/overview', isActive: true },
                { title: 'Team Member', path: '', isActive: true },
                { title: state?.employeeName, path: `/profilecontainer${state?.redirect?.split('tab')[0]}&tab=Touchbase`, isActive: true },
                { title: 'Touchbase Form', path: '/', isActive: false },
            ]);
        }
        // setbreadCrumbsData(state?.View ?
        //     [
        //         { title: 'Dashboard', path: '/overview', isActive: true },
        //         { title: 'Team Member', path: '', isActive: true },
        //         { title: state?.employeeName, path: `/profilecontainer${state?.redirect?.split('tab')[0]}&tab=Touchbase`, isActive: true },
        //         { title: 'Touchbase Form', path: '/', isActive: false },
        //     ] : [])

        if (touchbaseId) {
            setIsLoading(false);
            let validReportsTo = false;
            setbreadCrumbsData(
                userDetails.role != 'Team Member'
                    ? [
                        { title: 'Dashboard', path: '/overview', isActive: true },
                        { title: 'Team Member', path: '', isActive: true },
                        { title: 'Touchbase', path: '/touchbase', isActive: true },
                        { title: 'Edit Touchbase Form', path: '', isActive: false },
                    ]
                    : []
            );
            getIndividualTouchbase({ touchbaseId: touchbaseId }).then((res) => {
                let arr = [];
                let list = [];

                if (res.data.ResponseData.created_by_id == encryptStorage.getItem("employeeId")) {
                    validReportsTo = true;

                }


                if (validReportsTo) {
                    res.data.ResponseData.attendees.forEach((element) => {
                        arr.push(element.attendees);
                        let obj = {
                            value: element.attendees,
                            label: element.employee_name,
                            username: element.employee_name,
                        };
                        list.push(obj);
                    });
                    setSelectedPeopleList(list);

                    let individualData = {
                        touchbaseTitle: res.data.ResponseData.title,
                        touchbaseDescription: res.data.ResponseData.description,
                        touchbaseType: res.data.ResponseData.type,
                        touchbaseDate: res.data.ResponseData.touchabse_date,
                        touchbaseStartTime: res.data.ResponseData.start_time,
                        touchbaseEndTime: res.data.ResponseData.end_time,
                        touchbaseStatus_id: res.data.ResponseData.status_id,
                        touchbaseAttendees: list,
                        touchbaseId: res.data.ResponseData.id,
                    };
                    setOldSelectedValue(list);
                    setTouchbaseData(individualData);
                    setTouchbaseDataOld(individualData);
                    setPageMode(true);
                    setIsLoading(true);
                } else {
                    navigate('/', { state: { hideNav: false } });
                }
            });
        }
        touchbaseData.touchbaseType = state?.touchbase;
        setTouchbaseData({ ...touchbaseData });
        setTouchbaseDataOld({ ...touchbaseDataOld });

        let result = state?.touchbase === 'team' ? bind('team') : bind('');

    };

    const validation = () => {
        //
        let result = true;
        if (touchbaseData.touchbaseTitle.trim() === '') {
            result = false;
            setTouchbaseValidation('Touchbase title is required');
        } else {
            let checkregex = OnlyNumberSpecialChar(touchbaseData.touchbaseTitle);
            if (checkregex) {
                result = false;
                setTouchbaseValidation('Touchbase title is not valid');
            } else {
                setTouchbaseValidation('');
            }
        }

        if (touchbaseData.touchbaseDescription.trim() === '') {
            result = false;
            setdescriptionValidation('Touchbase Description is required');
        } else {
            let checkregex = OnlyNumberSpecialChar(touchbaseData.touchbaseDescription);
            if (checkregex) {
                result = false;
                setdescriptionValidation('Description is not valid');
            } else {
                setdescriptionValidation('');
            }
        }

        if (selectedPeopleList.length === 0) {
            result = false;
            settouchbaseAttendees('Attendees is required');
        } else settouchbaseAttendees('');

        if (touchbaseData.touchbaseDate === '') {
            result = false;
            setDateDetails('Date is required');
        } else if (touchbaseData.touchbaseDate < moment().format('YYYY-MM-DD')) {
            result = false;
            setDateDetails('Select a date from the current date');
        } else setDateDetails('');

        if (touchbaseData.touchbaseStartTime === '') {
            result = false;
            setStartTime('Start time is required');
        } else setStartTime('');

        if (touchbaseData.touchbaseEndTime === '') {
            result = false;
            setEndTime('End time is required');
        } else if (touchbaseData.touchbaseEndTime < touchbaseData.touchbaseStartTime) {
            result = false;
            setEndTime('End time must be greater than Start time');
        } else setEndTime('');

        return result;
        // if (touchbaseData.touchbaseEndTime !== '' && touchbaseData.touchbaseStartTime !== ''
        //     && touchbaseData.touchbaseTitle !== '' && touchbaseData.touchbaseDate !== '' && !(touchbaseData.touchbaseDate < moment().format('YYYY-MM-DD')) &&
        //     !(touchbaseData.touchbaseEndTime < touchbaseData.touchbaseStartTime) && selectedPeopleList.length > 0) {
        //     return true
        // }
        // else return false
    };

    /**
     * PC_tF_13, PC_tF_15,PC_TF_16,PC_TF_17,PC_TF_18,PC_TF_19,PC_TF_20
     * touchbaseSubmit function is invoked when user click save button
     * pageMode is checked and post/update API is called then based on the response user is redirect to touchbase grid page
     */

    const touchbaseSubmit = async () => {



        let data = validation();
        let isSame = _.isEqual(touchbaseData, touchbaseDataOld);

        if (data && !isSame) {
            setdisableSubmitBtn(true);
            if (pageMode) {
                let attendees_arr = [];

                selectedPeopleList.map((value) => {
                    attendees_arr.push(value.value);
                });

                // touchbaseData.touchbaseAttendees = emp
                touchbaseData.touchbaseAttendees = attendees_arr;
                // touchbaseData.touchbaseAttendees = emp

                setTouchbaseData({ ...touchbaseData });

                let updateResponse = await updateTouchbase(touchbaseData);

                if (updateResponse.data.ResponseData.Message == 'Successfully updated') {

                    //
                    let res = await NotificationTrigger(
                        {
                            title: 'Touchbase',
                            message: 'Rescheduled a Touchbase',
                            route: `touchbase/`,
                            state: {},
                            to_employee: updateResponse.data.ResponseData.notificationTo,
                            by: userDetails.roleId,
                        },
                        updateResponse.data.ResponseData.notificationTo,
                        websocket
                    )
                    let checksession = !state?.View ? sessionStorage.setItem('touchbaseToast', 'updated') : null;
                    !state?.View
                        ? navigate('/touchbase', { state: { ...state, popUp: 'updated' } })
                        : state?.redirect?.includes('tab')
                            ? (window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=Touchbase`)
                            : (window.location.href = `/profilecontainer${state.redirect}&tab=Touchbase`);

                }
            } else {
                let postData = {
                    touchbaseTitle: touchbaseData.touchbaseTitle,
                    touchbaseDescription: touchbaseData.touchbaseDescription,
                    touchbaseType: touchbaseData.touchbaseType,
                    touchbaseDate: touchbaseData.touchbaseDate,
                    touchbaseStartTime: touchbaseData.touchbaseStartTime,
                    touchbaseEndTime: touchbaseData.touchbaseEndTime,
                    touchbaseStatus_id: 1,
                    touchbaseAttendees: emp,
                    touchbaseCreated_by: userDetails.roleId,
                };

                let postResponse = await postTouchbase(postData);

                if (postResponse.data.ResponseData.Message == 'Successfully updated') {

                    //
                    if (postResponse.data.ResponseData.notificationTo) {
                        //
                        let res = NotificationTrigger(
                            {
                                title: 'Touchbase',
                                message: state?.touchbase == 'team' ? 'Scheduled a Team Touchbase' : 'Scheduled a Touchbase with you',
                                route: `touchbase/`,
                                state: {},
                                to_employee: postResponse.data.ResponseData.notificationTo,
                                by: userDetails.roleId,
                            },
                            postResponse.data.ResponseData.notificationTo,
                            websocket
                        )
                        let checksession = !state?.View ? sessionStorage.setItem('touchbaseToast', 'inserted') : null;

                        !state?.View
                            ? navigate('/touchbase', { state: { ...state, popUp: 'inserted' } })
                            : state?.redirect?.includes('tab')
                                ? (window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=Touchbase`)
                                : (window.location.href = `/profilecontainer${state.redirect}&tab=Touchbase`);

                    }
                }
            }

        }
    };

    /**
     * PC_TF_12
     * @param {*} e OnchangeName function is invoked when user change the data
     */
    const OnChangeName = (e) => {
        ////
        setTouchbaseData({ ...touchbaseData, [e.target.name]: e.target.value });
    };

    const handleChange = (e) => {
        let selectedValue = [];
        let attend = [];
        selectedValue = e;
        e.map((data) => {
            attend.push(data.value);
        });
        setSelectedPeopleList(selectedValue);
        setEmp(attend);
        setTouchbaseData({ ...touchbaseData, ['touchbaseAttendees']: selectedValue });
    };

    return isLoading ? (
        <div className="container-fluid coverpic mt-5">
            <div className="row justify-content-around">
                <div className="col-md-8 p-4 mt-5 bg-white rounded-3 mb-5">
                    <BreadCrumbs data={breadCrumbsData} />

                    <p className="font-15 tt-bold touchbase-form-label">
                        {touchbaseId
                            ? 'Edit a Touchbase'
                            : state?.touchbase === 'team'
                                ? 'Schedule a Team Touchbase'
                                : 'Schedule a Individual Touchbase'}
                    </p>
                    {/*Form structure starts Here*/}
                    <div className="mb-3 col-md-12">
                        <label htmlFor="touchbase-title" className="form-label hive-form-label">
                            <span>
                                <img src="/Images/stopwatch.svg" className="me-2" alt="icon" />
                            </span>
                            Touchbase Title <span className="required">*</span>
                        </label>
                        <input
                            maxLength={255}
                            type="text"
                            className="form-control hive-form-control"
                            name="touchbaseTitle"
                            id="touchbase-title"
                            placeholder="Enter Touchbase Title"
                            value={touchbaseData.touchbaseTitle}
                            onChange={(e) => {
                                setTouchbaseValidation('');
                                OnChangeName(e);
                            }}
                        />
                        <label className="text-danger">{touchbaseValidation}</label>
                    </div>
                    <div className="mb-3 col-md-12">
                        <label htmlFor="touchbase-description" className="form-label hive-form-label">
                            Add a Description
                        </label>
                        <span className="required">*</span>
                        <textarea
                            maxLength={500}
                            className="form-control hive-form-control touchbase-comments"
                            id="touchbase-description"
                            name="touchbaseDescription"
                            onChange={(e) => {
                                setdescriptionValidation('');
                                OnChangeName(e);
                            }}
                            value={touchbaseData.touchbaseDescription}
                            placeholder="Enter Touchbase Description"
                            rows={3}
                        />
                        <label className="text-danger">{descriptionValidation}</label>
                    </div>
                    <div className="row mb-4">
                        <div className="col-md-3">
                            <label htmlFor="select-attendees" className="form-label hive-form-label">
                                Select the Attendees <span className="required">*</span>
                            </label>
                            {/* <input type="text" className="form-control hive-form-control" name='touchbaseAttendees' onChange={(e) => { OnChangeName(e) }} id="select-attendees" placeholder="Select-attendees" />  */}
                            <Select
                                className="dropdown"
                                name="touchbaseAttendees"
                                maxMenuHeight={150}
                                placeholder="Select attendees"
                                value={selectedPeopleList}
                                options={showEmployee} // set list of the data
                                onChange={(e) => {
                                    settouchbaseAttendees('');
                                    handleChange(e);
                                }} // assign onChange function
                                isMulti
                                isClearable
                            />
                            <label className="text-danger">{touchbaseAttendees}</label>
                        </div>
                    </div>
                    <p className="bold-text font-15 touchbase-form-label mb-2">Timeline</p>
                    <div className="row">
                        <div className="col-md-3">
                            <label htmlFor="touchbase-date" className="form-label hive-form-label">
                                Date <span className="required">*</span>
                            </label>
                            <input
                                min={moment().format('YYYY-MM-DD')}
                                type="date"
                                className="form-control hive-form-control"
                                name="touchbaseDate"
                                onChange={(e) => {
                                    setDateDetails('');
                                    OnChangeName(e);
                                }}
                                value={touchbaseData.touchbaseDate}
                                id="touchbase-date"
                                placeholder="Select Domain"
                            />
                            <label className="text-danger">{date}</label>
                        </div>
                        <div className="col-md-2">
                            <label htmlFor="start-time" className="form-label hive-form-label">
                                Start Time <span className="required">*</span>
                            </label>
                            <input
                                type="time"
                                className="form-control hive-form-control"
                                name="touchbaseStartTime"
                                onChange={(e) => {
                                    setStartTime('');
                                    OnChangeName(e);
                                }}
                                value={touchbaseData.touchbaseStartTime}
                                id="start-time"
                                placeholder="Select Domain"
                            />
                            <label className="text-danger">{startTime}</label>
                        </div>
                        <div className="col-md-2">
                            <label htmlFor="exampleInputEmail1" className="form-label hive-form-label">
                                End Time <span className="required">*</span>
                            </label>
                            <input
                                type="time"
                                className="form-control hive-form-control"
                                name="touchbaseEndTime"
                                onChange={(e) => {
                                    setEndTime('');
                                    OnChangeName(e);
                                }}
                                value={touchbaseData.touchbaseEndTime}
                                id="end-time"
                                placeholder="Select Domain"
                            />
                            <label className="text-danger">{endTime}</label>
                        </div>
                    </div>
                    <div className="col-md-12 d-flex justify-content-end mt-5">
                        <a
                            href={
                                !state?.View
                                    ? '/touchbase'
                                    : state?.redirect?.includes('tab')
                                        ? `/profilecontainer${state?.redirect?.split('tab')[0]}tab=Touchbase`
                                        : `/profilecontainer${state.redirect}&tab=Touchbase`
                            }
                        >
                            <button type="button" className="btn hive-btn-secondary me-4">
                                Cancel
                            </button>
                        </a>
                        <button
                            // disabled={disabledCheck}
                            type="button"
                            className=" btn hive-btn-primary"
                            onClick={() => {
                                touchbaseSubmit();
                            }}
                            disabled={touchbaseId ? (disabledCheck || disableSubmitBtn) : disableSubmitBtn}
                        >
                            {touchbaseId ? 'Reschedule a Touchbase' : 'Schedule a Touchbase'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <Loader isLoading={isLoading} />
    );
}

function mapStateToProps(state) {
    return {
        websocket: state.webSocketAPI,
    };
}

export default connect(mapStateToProps)(TouchbaseForm);
